import { downloadImageAsBase64, getImageUrl, getContent } from '@feelrobotics/strapi-sdk';

async function getConnectingDeviceImages(deviceName: string) {
  const searchString = `fm-device-connects?filters[entry_name][$eq]=${deviceName}-connect`;

  const data = await getContent(searchString);
  return {
    connecting: await downloadImageAsBase64(getImageUrl(data, 'connecting')),
    successful: await downloadImageAsBase64(getImageUrl(data, 'successful')),
    failed: await downloadImageAsBase64(getImageUrl(data, 'failed')),
  };
}
export { getConnectingDeviceImages };
